export enum SwapQualityIssueReportedBy {
    YourCenter = 1,
    OtherCenters = 2,
    EitherCenter = 3
}